import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase/config";
import './styles/AvailableProducts.css';
import Loader from "./Loader";
import { signOut } from 'firebase/auth';
import { auth } from '../firebase/config';
import { FaMapMarkerAlt } from 'react-icons/fa'; 
const AvailableProducts = () => {
  const [loading, setLoading] = useState(true);
  const [products, setProducts] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();
  const { state } = useLocation();
  const location = state?.location;
  const currentAddress = state?.currentAddress;
  const user = state?.user;

  useEffect(() => {
    if (!location) {
      setErrorMessage("No location data found.");
      setLoading(false);
      return;
    }

    const fetchNearbyProducts = async () => {
      try {
        const lat = parseFloat(location.lat);
        const lon = parseFloat(location.lng);
        const calculateDistance = httpsCallable(functions, "calculatedistance");
        const response = await calculateDistance({ latitude: lat, longitude: lon });

        const vendorDocSnap = response?.data?.results;
        if (Array.isArray(vendorDocSnap)) {
          const allProducts = [];
          const seenProductNames = new Set();

          vendorDocSnap.forEach((vendor) => {
            const productsObj = vendor.products;
            if (productsObj && typeof productsObj === 'object') {
              Object.entries(productsObj).forEach(([productName, productData]) => {
                if (!seenProductNames.has(productName)) {
                  seenProductNames.add(productName);
                  allProducts.push({
                    name: productName,
                    ...productData,
                  });
                }
              });
            }
          });

          if (allProducts.length === 0) {
            setErrorMessage("There are no products in your location as of now. Only select locations like Tindivanam or Chennai are currently supported.");
          } else {
            setProducts(allProducts);
          }
        } else {
          setErrorMessage("No vendor data returned.");
        }
      } catch (error) {
        console.error('Error fetching products:', error);
        setErrorMessage("There are no products in your location as of now. Only select locations like Tindivanam or Chennai are currently supported.");
      } finally {
        setLoading(false);
      }
    };

    fetchNearbyProducts();
  }, [location]);

  const handleProductClick = (productName, productImage,productUnits) => {
    navigate('/bestdealinput', {
      state: {
        productName,
        location,
        currentAddress,
        user,
        productImage,
        productUnits
      }
    });
  };

  const handleChangeLocation = () => {
    navigate('/locationscreen', {
      state: {
        user,
      }
    });
  };

  return (
    <div className="products-container">
      {loading && <Loader />}

      <div className="user-header">
        <div className="profile-details">
          <img src={user?.photoURL} alt="User" className="user-avatar" />
          <div>
            <h4>{user?.name}</h4>
            <p>{user?.email}</p>
          </div>
        </div>
        <button onClick={handleLogout} className="logout-link">Log Out</button>
      </div>

      <div className="location">
        <span className="location-icon">📍</span>
        <span>{currentAddress}</span>
      </div>

      <h3 className="section-title">Available products for your location</h3>

      {/* Show error card instead of redirect */}
      {errorMessage ? (
        <div className="error-card">
          <p>{errorMessage}</p>
          <button className="change-location-btn" onClick={handleChangeLocation}>
            Change Location
          </button>
        </div>
      ) : (
        <div className="product-list">
          {products.map((product, idx) => (
            <div
              className="product-card"
              key={idx}
              onClick={() => handleProductClick(product.name, product.imageUrl,product.units)}
            >
              <img
                src={product.imageUrl}
                alt={product.name}
                className="product-image"
              />
              <span className="product-label">{product.name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
const handleLogout = async () => {
  await signOut(auth);
  window.location.href = '/'; // refresh to go to welcome screen
};
export default AvailableProducts;
